export const fixedNumber = (number: number, digits: number = 2): number => {
  return Number(number.toFixed(digits));
};

export const padWithZeros = (num: number | undefined, width: number): string => {
  if (!num) {
    return "";
  }

  const numStr = num.toString();
  return numStr.padStart(width, "0");
};

/**
 * Parses a base-10 unsigned integer string (ASCII digits only) into a number.
 * - Rejects whitespace, signs, decimals, and non-digits (e.g. " 42", "-1", "2a", "3.14")
 * - Throws TypeError for invalid format and RangeError for non-safe integers
 */
export function parseUnsignedIntStrict(str: string): number {
  const s = str.trim();
  if (!/^\d+$/.test(s)) {
    throw new TypeError(`Invalid unsigned integer string: "${str}"`);
  }
  const n = Number(s);
  if (!Number.isSafeInteger(n)) {
    throw new RangeError(`Not a safe integer: ${s}`);
  }
  return n;
}
